import { render, staticRenderFns } from "./call-incoming-icon.vue?vue&type=template&id=404189b6"
import script from "./call-incoming-icon.vue?vue&type=script&lang=js"
export * from "./call-incoming-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports